import { Serializable } from '../../core/models/serializable';

export class SendInvoiceRequestModel
  implements Serializable<SendInvoiceRequestModel>
{
  fromObject(object: any): SendInvoiceRequestModel {
    Object.assign(this, object);
    return this;
  }
  toObject() {
    return {
      MarkedEntities: this.markedEntities,
      ChosenCustomerAgents: this.chosenCustomerAgents,
    };
  }

  public markedEntities: number[];
  public chosenCustomerAgents: number[];
}
